//TODO importing magnific might be redundant? Its also included in the common.js script 
// which is included on the page but doesn't work without importing it here as well
import 'magnific-popup';
import './kony-sdk.js';

(($) => {

//TODO this should be redundant? also included in the common.js script like the need to import magnific popup
$(document).on('click', '.js-close-popup', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
});

const login = {
    appKey: site_data.OLB.appKey,
    appSecret: site_data.OLB.appSecret,
    serviceURL: site_data.OLB.serviceURL,
    olbURL: site_data.OLB.olbURL,
    providerName: 'DbxUserLogin',
    lang: 'en',
    loginForms: document.getElementsByClassName('login-form'),
    submittedForm: '',
    token: ''
}

const initLogin = () => {

    let un = login.submittedForm[0].value;
    let sum = 0;
    let sumstr = "";
    let revstr = "";
    for (let i = 0; i < un.length; i++) {
      sum += un.charCodeAt(i);
    }
    sum *= 1080; //site_data.OLB.transaction_days;
    sumstr = btoa(sum);
    revstr = sumstr.split("").reverse().join("");

    // check if OLB is blocked - this catched the edge that that a user
    // loads the page before its blocked but submitts the login after its blocked
    // Expected output when blocked: {success: true, blocked: true}
    // Expected output when not blocked: {success: true, blocked: false}
    fetch(`${site_data.WP_AJAX}?action=is_olb_blocked`)
        .then(response => response.json())
        .then(result => {
            //console.log(result);
            if( result.blocked ){
                //dont conutine, set error message
                let message = login.lang == 'es' ? site_data.OLB.error_default_es : site_data.OLB.error_default_en;
                displayError(message,'error_default');
                login.submittedForm.querySelector('.btn').classList.remove('btn--loading', 'btn--disabled');
                login.submittedForm.querySelector('.btn').disabled = false;
            
            // else not blocked lets continue logging in
            } else{
                
                const client = new kony.sdk();
                //set Pragma Header to disable the use of response cache in browsers.
                client.setGlobalRequestParam("Pragma", "no-cache", client.globalRequestParamType.headers);
                client.setGlobalRequestParam("X-Kony-Passthrough", revstr.substring(2), client.globalRequestParamType.headers);

                client.init(login.appKey, login.appSecret, login.serviceURL, 
                    (response) => {
                        processLogin(client);
                    }, 
                    (error) => {
                        let message = login.lang == 'es' ? site_data.OLB.error_default_es : site_data.OLB.error_default_en;
                        displayError(message,'error_default');
                        login.submittedForm.querySelector('.btn').classList.remove('btn--loading', 'btn--disabled');
                        login.submittedForm.querySelector('.btn').disabled = false;
                    }
                );
            }
        });

}

const processLogin = (client) => {
        let authClient = null;
        try {
            authClient = client.getIdentityService(login.providerName);
        } catch (exception) {
            let message = login.lang === 'es' ? site_data.OLB.error_default_es : site_data.OLB.error_default_en;
            displayError(message,'error_default');

            login.submittedForm.querySelector('.btn').classList.remove('btn--loading', 'btn--disabled');
            login.submittedForm.querySelector('.btn').disabled = false;
            return;
        }

        let username = login.submittedForm.querySelector('input[name="username"]').value; 
        let password = login.submittedForm.querySelector('input[name="password"]').value;

        let reqObj = {
            "Password" : password,
            "Channel" : "OLB"
        };

        if(username && username.length <= 10 && !isNaN(username)){ 
            reqObj.Account = username; 
        } else { 
            reqObj.UserName = username; 
        }

        authClient.login(reqObj, (response) => {
            
            const provider = kony.sdk.getCurrentInstance().tokens.DbxUserLogin.provider_token.params.user_attributes.identityProvider;
            
            if(provider === "OKTA"){
                login.token =  kony.sdk.getCurrentInstance().tokens.DbxUserLogin.provider_token.params.security_attributes.okta_value;
            } else {
                login.token = kony.sdk.getCurrentInstance().tokens.DbxUserLogin.provider_token.value;
            }
            
            //check if maintenance message and show it or continue to OLB
            checkMaintenance();

            login.submittedForm.querySelector('.btn').classList.remove('btn--loading', 'btn--disabled');
            login.submittedForm.querySelector('.btn').disabled = false;

        }, (error) => {
            //LOGIN VALIDATION FAILED SHOW CORRECT ERROR MESSAGES
            if (error.details.errcode == 10107) {

                if (error.details.errmsg.indexOf("locked") > -1) {
                    //"10107 - LOCKED"
                    let message = login.lang === 'es' ? site_data.OLB.error_10107_locked_es : site_data.OLB.error_10107_locked_en;
                    displayError(message,'error_10107_locked');
                } else {
                    //10107 - INVALID
                    let message = login.lang === 'es' ? site_data.OLB.error_10107_invalid_es : site_data.OLB.error_10107_invalid_en;
                    displayError(message,'error_10107_invalid');
                }

            } else if (error.details.errcode === 10105) {
                //10105 - LOCKED
                let message = login.lang === 'es' ? site_data.OLB.error_10105_locked_es : site_data.OLB.error_10105_locked_en;
                displayError(message,'error_10105_locked');
            } else {
                //ERROR - DEFAULT
                let message = login.lang === 'es' ? site_data.OLB.error_default_es : site_data.OLB.error_default_en;
                displayError(message,'error_default');
            }

            //renable submit button
            login.submittedForm.querySelector('.btn').classList.remove('btn--loading', 'btn--disabled');
            login.submittedForm.querySelector('.btn').disabled = false;
        });
    //end process login
}

const checkMaintenance = () => {

    //OLB to redirect to after checking for and showing maintenance message
    let reDirectURL = login.olbURL + login.token;

    //if there is a message to show
    if( document.getElementById('popup-login-maintenance') ){

        //update popups continue button to the appropriate url
        $('#popup-login-maintenance .btn').attr('href', reDirectURL);

        $.magnificPopup.open({
            items: {
                type: 'inline',
                src: '#popup-login-maintenance',
            },
            alignTop: true,
            fixedContentPos: true,
            mainClass: 'mfp-fade mfp-speedbump',
            showCloseBtn: false,
            modal: true,

        });
    }
    else{
        //there is no maintenance announcement so continue to OLB
        window.location.replace(reDirectURL);
    }
}

const displayError = (message,type='') => {
    let messageMarkup = `<div class="form-message error" data-type="${type}">${message}</div>`;
    if( login.submittedForm.querySelector('.error:not(.error--browser)') ){
        login.submittedForm.querySelector('.error:not(.error--browser)').remove();
    }
    login.submittedForm.querySelector('.login-form__footer').insertAdjacentHTML('beforebegin',messageMarkup);
}


//loop through any login forms and init login on submit
Array.from(login.loginForms).forEach(form =>{
    form.addEventListener('submit',(event) => {
    
        event.preventDefault();
        form.querySelector('.btn').classList.add('btn--loading', 'btn--disabled');
        form.querySelector('.btn').disabled = true;
        login.submittedForm = form;
        //make sure any previous errors are cleared out when submitting
        if( login.submittedForm.querySelector('.error:not(.error--browser)') ){
            login.submittedForm.querySelector('.error:not(.error--browser)').remove();
        }
        
        initLogin();

    });
});

//spanishClick - translate labels and messaging to spanish
const translateLink = document.getElementsByClassName('js-translate-login');
Array.from(translateLink).forEach(link => {
    link.addEventListener('click',(event)=>{

        let type = link.dataset.type;
        //set login to spanish so if new errors display the proper langauge is shown
        if( type === 'es' ){
            login.lang = 'es';
            $('#service-language').html("Los acuerdos, documentos, productos y servicios serán proporcionados solo en inglés.");
            $('#service-language').attr('style','margin-bottom:20px');
            $('#login_box_headline').html(site_data.OLB.popup_headline_es);
            $('#sidebox1_headline').html(site_data.OLB.popup_box1_headline_es);
            $('#sidebox1_link').html(site_data.OLB.popup_box1_link_text_es).attr("href",site_data.OLB.popup_box1_link_url_es);
            $('#sidebox2_headline').html(site_data.OLB.popup_box2_headline_es);
            $('#sidebox2_link').html(site_data.OLB.popup_box2_link_text_es).attr("href",site_data.OLB.popup_box2_link_url_es);
        }
        else{
            login.lang = 'en';
            $('#service-language').html("");
            $('#service-language').attr('style','');
            $('#login_box_headline').html(site_data.OLB.popup_headline_en);
            $('#sidebox1_headline').html(site_data.OLB.popup_box1_headline_en);
            $('#sidebox1_link').html(site_data.OLB.popup_box1_link_text_en).attr("href",site_data.OLB.popup_box1_link_url_en);
            $('#sidebox2_headline').html(site_data.OLB.popup_box2_headline_en);
            $('#sidebox2_link').html(site_data.OLB.popup_box2_link_text_en).attr("href",site_data.OLB.popup_box2_link_url_en);
        }

        //loop through any login forms
        Array.from(login.loginForms).forEach(form =>{
            
            let langLink = form.querySelector('.translate-link');
            let userLabel = form.querySelector("input[name='username'] + label");
            let passLabel = form.querySelector("input[name='password'] + label");
            let submit = form.querySelector("button[type='submit']");
            let cantLink = form.querySelector('.cant-login-link');
            let enrollLink = form.querySelector('.enroll-link');
            let errors = form.querySelectorAll('.error');
            
            //TRANSLATE TO SPANISH
            if( type === 'es' ){
                
                //translation link
                langLink.textContent = 'English';
                langLink.dataset.type = 'en';
    
                //username = identificación de usuario
                userLabel.textContent = "Identificación de usuario";

                //password = contraseña
                passLabel.textContent = "Contraseña";

                //Login (submit button) = Iniciar sesión
                submit.textContent = "Iniciar sesión";

                //Cant Login = no puedo iniciar sesión
                cantLink.textContent = site_data.OLB.cant_login_es_text;
                cantLink.setAttribute("href",site_data.OLB.cant_login_es_url);

                //Enroll in Online Banking = Inscríbase en la Banca en Línea
                if( typeof(enrollLink) != 'undefined' && enrollLink != null ){
                    enrollLink.textContent = site_data.OLB.enroll_link_es_text;
                    enrollLink.setAttribute("href",site_data.OLB.enroll_link_es_url);
                }

                //translate each error according to type
                if( typeof(errors) != 'undefined' && errors != null ){
                    Array.from(errors).forEach(error => {
                        
                        let errortype = error.dataset.type;
                        if( errortype === 'error_browser'){
                            error.innerHTML = site_data.OLB.olb_browser_message.spanish
                        }
                        else if( errortype === 'error_10107_locked' ){
                            error.textContent = site_data.OLB.error_10107_locked_es;
                        }
                        else if( errortype === 'error_10107_invalid' ){
                            error.textContent = site_data.OLB.error_10107_invalid_es;
                        }
                        else if( errortype === 'error_10105_locked' ){
                            error.textContent = site_data.OLB.error_10105_locked_es;
                        }
                        else if( errortype === 'error_default' ){
                            error.textContent = site_data.OLB.error_default_es;
                        }

                    });
                }//end if errors

                //popup login box

            //ELSE TRANSLATE TO ENGLISH
            }else{
                langLink.textContent = 'Español';
                langLink.dataset.type = 'es';
    
                userLabel.textContent = "Username";

                passLabel.textContent = "Password";

                submit.textContent = "Log In";

                cantLink.textContent = site_data.OLB.cant_login_en_text;
                cantLink.setAttribute("href",site_data.OLB.cant_login_en_url);

                if( typeof(enrollLink) != 'undefined' && enrollLink != null  ){
                    enrollLink.textContent = site_data.OLB.enroll_link_en_text;
                    enrollLink.setAttribute("href",site_data.OLB.enroll_link_en_url);
                }

                //translate each error according to type
                if( typeof(errors) != 'undefined' && errors != null ){
                    Array.from(errors).forEach(error => {
                        
                        let errortype = error.dataset.type;
                        
                        if( errortype === 'error_browser'){
                            error.innerHTML = site_data.OLB.olb_browser_message.english
                        }
                        else if( errortype === 'error_10107_locked' ){
                            error.textContent = site_data.OLB.error_10107_locked_en;
                        }
                        else if( errortype === 'error_10107_invalid' ){
                            error.textContent = site_data.OLB.error_10107_invalid_en;
                        }
                        else if( errortype === 'error_10105_locked' ){
                            error.textContent = site_data.OLB.error_10105_locked_en;
                        }
                        else if( errortype === 'error_default' ){
                            error.textContent = site_data.OLB.error_default_en;
                        }

                    });

                    //popup login box

                }

            }//end else

        });//end loginforms loop
        
    });
});

//BROWSER CHECK - if unsuported browser display error message with login form
const browserCheck = browser => {
    let supported = true;

    let ieRegex = /(?=.*(trident)).*/i;
	let edgeRegex = /(?=.*(edge)).*/i;

    //bad chrome check
    let badChrome = false;
    let chromePieces = browser.match(/Chrom(?:e|ium)\/([0-9]+)\.([0-9]+)\.([0-9]+)\.([0-9]+)/);
    if (chromePieces != null && chromePieces.length === 5) {
        chromePieces = chromePieces.map(piece => parseInt(piece, 10));
        badChrome = (chromePieces[1] === 95 && chromePieces[2] === 0 && chromePieces[3] === 4638 && chromePieces[4] < 69);
    }
    
    //if unsupported IE, unsupported Edge, or unsuported Chrome
    if( ieRegex.test(browser) || edgeRegex.test(browser) || badChrome ){
        supported = false;
    }

    return supported;
}

//if unsupported browser, display a message
if( !browserCheck(navigator.userAgent) ){
    //console.log(site_data.OLB.olb_browser_message.english);
    let messageMarkup = `<div class="form-message error error--browser" data-type="error_browser">${site_data.OLB.olb_browser_message.english}</div>`;
    
    //insert unsuppported browser message to login form on hero and in popup
    const heroLoginForm = document.getElementById('hero-login-form');
    if (heroLoginForm) {
        heroLoginForm.querySelector('.login-form__footer').insertAdjacentHTML('beforebegin', messageMarkup);
    }
    
    const popupLoginForm = document.getElementById('popup-login-form');
    if (popupLoginForm) {
        popupLoginForm.querySelector('.login-form__footer').insertAdjacentHTML('beforebegin', messageMarkup);
    }
}

})(jQuery)